// src/pages/examiner/ExaminerDashboard.jsx (Finalized with New Features)

import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext.jsx';
import DashboardCard from '../../components/DashboardCard.jsx';
import { Link } from 'react-router-dom';

// FIX: Change to the correct two-level depth path: ../../firebase/firebase.js
import { db } from '../../firebase/firebase.js';

// --- NEW COMPONENT IMPORT ---
import GradingInterface from '../../components/GradingInterface';


// --- 1. Examiner Management Component --- (REMAINS UNCHANGED)
function ExaminerManagement() {
    const { manageExaminer } = useAuth();
    const [examinerUid, setExaminerUid] = useState('');
    const [subjects, setSubjects] = useState(''); // Comma-separated string
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    // ... (rest of the component remains unchanged) ...

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");
        setLoading(true);

        const subjectsArray = subjects.split(',').map(s => s.trim()).filter(s => s.length > 0);

        // ... (rest of the logic remains the same)
        try {
            await manageExaminer({
                uid: examinerUid.trim(),
                subjects: subjectsArray,
            });
            setMessage('Examiner profile saved.');
            setExaminerUid('');
            setSubjects('');

        } catch (err) {
            const errorMessage = err.message || 'Failed to update examiner profile.';
            setMessage(`Error: ${errorMessage}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <DashboardCard title="Manage Examiners & Subjects" className="w-full">
            <form onSubmit={handleSubmit} className="space-y-4">
                <p className="text-sm text-gray-500">Designate users as examiners and assign their subjects of expertise.</p>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Examiner User ID (UID)</label>
                    <input
                        type="text"
                        value={examinerUid}
                        onChange={(e) => setExaminerUid(e.target.value)}
                        required
                        className="mt-1 w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:focus:border-blue-500"
                        placeholder="Enter Examiner UID"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Subjects (Comma Separated)</label>
                    <input
                        type="text"
                        value={subjects}
                        onChange={(e) => setSubjects(e.target.value)}
                        required
                        className="mt-1 w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Math, Physics, English"
                    />
                </div>
                <button
                    type="submit"
                    disabled={loading}
                    className="w-full bg-blue-600 text-white p-2 rounded-md font-semibold hover:bg-blue-700 disabled:bg-gray-400"
                >
                    {loading ? 'Saving Profile...' : 'Save Examiner Profile'}
                </button>
            </form>
            {message && (
                <p className={`mt-4 text-sm font-semibold ${message.startsWith('Error') ? 'text-red-600' : 'text-green-600'}`}>
                    {message}
                </p>
            )}
        </DashboardCard>
    );
}

// --- 2. Admin Dashboard Utility (Assignment Trigger) --- (REMAINS UNCHANGED)
function AssignmentControl() {
    const { assignAllPendingSubmissions } = useAuth();
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const handleAssign = async () => {
        setLoading(true);
        setMessage('');
        try {
            const result = await assignAllPendingSubmissions();
            setMessage(result.message);
        } catch (err) {
            setMessage(`Error: ${err.message}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <DashboardCard title="Assignment Controls" className="w-full">
            <h4 className="font-semibold text-lg mb-2">Automate Grading Distribution</h4>
            <p className="text-sm text-gray-600 mb-4">
                This process finds all submissions needing manual grading and assigns them to the qualified examiner with the lowest workload.
            </p>
            <button
                onClick={handleAssign}
                disabled={loading}
                className="w-full bg-indigo-600 text-white p-2 rounded-md font-semibold hover:bg-indigo-700 disabled:bg-gray-400"
            >
                {loading ? 'Processing...' : 'Assign Pending Submissions'}
            </button>
            {message && <p className={`mt-3 text-sm font-semibold ${message.startsWith('Error') ? 'text-red-600' : 'text-green-600'}`}>{message}</p>}
        </DashboardCard>
    );
}


// --- 3. Main Examiner Dashboard Component (Functional Content) ---
export default function ExaminerDashboard() {
    const { userProfile } = useAuth();

    return (
        <div className="p-8 space-y-8 bg-gray-50 min-h-screen">
            <h1 className="text-3xl font-extrabold text-gray-900 mb-6">
                Examiner Grading Dashboard
                {userProfile?.role && <span className="text-xl text-indigo-600 ml-3">({userProfile.role})</span>}
            </h1>

            {/* --- NEW: INTEGRATE THE GRADING INTERFACE --- */}
            <div className="p-6 bg-white rounded-lg shadow-xl">
                 <h2 className="text-2xl font-bold mb-4 border-b pb-2">Submissions Awaiting Your Review</h2>
                 <GradingInterface />
            </div>

            {/* --- STAFF/ADMIN Support Link --- */}
            <div className="pt-4 border-t">
                <Link to="/staff/my-tickets" className="text-sm text-red-600 hover:text-red-800 font-medium">
                    Have an issue? Submit a Staff Support Request &rarr;
                </Link>
            </div>
        </div>
    );
}
